import { Card } from "@mui/material";
import PropTypes from "prop-types";
import { AppColors } from "../resources/AppColors";

const CardMonitoring = (props) => {
  const { children, bg, height, width } = props;
  return (
    <Card
      className="w-100 mb-3"
      style={{
        boxShadow: "3px 3px 3px 1px rgba(0,0,0,.16)",
        borderRadius: 10,
        height: height,
        width: width,
        backgroundColor: bg,
        color: AppColors.PRIMARY,
      }}
    >
      {children}
    </Card>
  );
};

CardMonitoring.propTypes = {
  children: PropTypes.node.isRequired,
  bg: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
};

CardMonitoring.defaultProps = {
  bg: AppColors.WHITE,
};

export default CardMonitoring;
